import client from './client';

export type Vertical = 'grocery' | 'food';

export interface MasterItem {
  id: number;
  name: string;
  vertical?: Vertical;
  category: string;
  subcategory?: string;
  unit: string;
  default_weight?: string;
  mrp_hint?: number;
  image_url?: string;
  thumbnail_url?: string;
  is_veg: boolean;
  is_halal?: boolean;
  default_discount_percent?: number;
}

export interface StoreCarryingItem {
  product_id: number;
  store_id: number;
  store_name: string;
  store_city?: string;
  store_rating: number;
  store_is_open: boolean;
  store_vertical: Vertical;
  price: number;
  mrp?: number;
  effective_price: number;
  effective_discount_percent: number;
  stock_quantity: number;
  image_url?: string;
  thumbnail_url?: string;
}

export interface MasterItemBulkAddRow {
  master_item_id: number;
  price: number;
  mrp?: number;
  stock_quantity: number;
  discount_percent?: number;
}

export const catalogAPI = {
  async listCategories(params: { vertical?: Vertical } = {}): Promise<{ category: string; count: number }[]> {
    const res = await client.get('/api/catalog/categories', { params });
    return res.data;
  },
  async listMasterItems(params: { q?: string; category?: string; vertical?: Vertical; skip?: number; limit?: number } = {}): Promise<MasterItem[]> {
    const res = await client.get<MasterItem[]>('/api/catalog/master-items', { params });
    return res.data;
  },
  async getMasterItem(itemId: number): Promise<MasterItem> {
    const res = await client.get<MasterItem>(`/api/catalog/master-items/${itemId}`);
    return res.data;
  },
  async getStoresCarryingItem(itemId: number, inStockOnly: boolean = true): Promise<{ item: MasterItem; stores: StoreCarryingItem[] }> {
    const res = await client.get(`/api/catalog/master-items/${itemId}/stores`, { params: { in_stock_only: inStockOnly } });
    return res.data;
  },
  async bulkAddToInventory(items: MasterItemBulkAddRow[]): Promise<{ created: number; skipped: number }> {
    const res = await client.post('/api/catalog/stores/me/inventory/bulk-add', { items });
    return res.data;
  },
  async updateDefaultDiscount(default_discount_percent: number): Promise<{ default_discount_percent: number }> {
    const res = await client.patch('/api/catalog/stores/me/default-discount', { default_discount_percent });
    return res.data;
  },
  /** Clone every MasterItem this store doesn't yet carry into its inventory (idempotent). */
  async syncMyStoreWithMaster(): Promise<{ store_id: number; created: number }> {
    const res = await client.post('/api/catalog/stores/me/sync-master');
    return res.data;
  },
  /** Toggle Available / Out-of-stock for one of the store's products. */
  async setProductAvailability(
    productId: number,
    isAvailable: boolean,
    stockQuantity?: number,
  ): Promise<{ product_id: number; is_available: boolean; stock_quantity: number }> {
    const res = await client.patch(
      `/api/catalog/stores/me/products/${productId}/availability`,
      { is_available: isAvailable, stock_quantity: stockQuantity },
    );
    return res.data;
  },
};

